import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import missionService from "../../services/missionService";
export const MissionItem = ({ item, setRoute }) => {
    const { t } = useTranslation();
    const showMissionRoute = async (missionId) => {
        missionService.getMissionRoutePoints(missionId).then((data) => {
            setRoute(data.routePoints.map((item) => ({
                lat: item.latitude,
                lng: item.longitude,
                alt: item.altitude,
            })), data.destinationPoints.map((item) => ({
                lat: item.latitude,
                lng: item.longitude,
            })));
        });
    };
    const downloadGPXTrack = async (missionId) => {
        const file = await missionService.downloadTrack(missionId);
        const link = document.createElement("a");
        //link.target = '_blank';
        link.href = URL.createObjectURL(file);
        link.download = "track.gpx";
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("div", { children: item.startDate }), _jsx("div", { children: item.endDate }), _jsx("div", { children: item.operatorName }), _jsx("div", { children: _jsx("button", { className: "btn", onClick: () => showMissionRoute(item.missionId), children: t("missionItem.buttons.viewRoute") }) }), _jsx("div", { children: _jsx("button", { className: "btn", onClick: () => downloadGPXTrack(item.missionId), children: t("missionItem.buttons.downloadGpx") }) })] }) }));
};
